module.exports = __webpack_public_path__ + "static/media/0_2019_03_04.d9a86713.jpg";